import { graphql } from "react-relay";

export const suggestionCardHeaderFragments = {
  org: graphql`
    fragment SuggestionCardHeader_org on Org {
      experiments
      primaryTeam {
        __typename
        ... on Team {
          teamName
        }
        ... on GraphEntityError {
          statusCode
          message
        }
      }
    }
  `,
  feedSuggestion: graphql`
    fragment SuggestionCardHeader_feedSuggestion on FeedSuggestion {
      occurredMillis
      suggestionId
      suggestionType
      text {
        title
        subHeading
      }
      suggestionPayload {
        __typename
        ... on SuggestionResultChromeExtensionTipPayload {
          tipType
        }
        ... on SuggestionResultMissingUserConfigurationPayload {
          configurationType
        }
      }
    }
  `,
};
